import { isObject, isString } from './types';

const hasOwnProperty = Object.prototype.hasOwnProperty;

export function noop() {
};

export function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
};

export function extend(target, ...rest) {
  for (let i = 0; i < rest.length; i++) {
    let source = rest[i];
    for (let key in source) {
      target[key] = source[key];
    }
  }
  return target;
}

export function toObject(arr) {
  var res = {};
  for (let i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res;
};

export const getValueByPath = function(object, prop) {
  prop = prop || '';
  const paths = prop.split('.');
  let current = object;
  let result = null;
  for (let i = 0, j = paths.length; i < j; i++) {
    const path = paths[i];
    if (!current) break;

    if (i === j - 1) {
      result = current[path];
      break;
    }
    current = current[path];
  }
  return result;
};

export function getPropByPath(obj, path, strict) {
  let tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, '.$1');
  path = path.replace(/^\./, '');

  let keyArr = path.split('.');
  let i = 0;
  for (let len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj && !strict) break;
    let key = keyArr[i];
    if (key in tempObj) {
      tempObj = tempObj[key];
    } else {
      if (strict) {
        throw new Error('please transfer a valid prop path to form item!');
      }
      break;
    }
  }
  return {
    o: tempObj,
    k: keyArr[i],
    v: tempObj ? tempObj[keyArr[i]] : null
  };
};

export const generateId = function() {
  return Math.floor(Math.random() * 10000);
};

export const valueEquals = (a, b) => {
  // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
  if (a === b) return true;
  if (!(a instanceof Array)) return false;
  if (!(b instanceof Array)) return false;
  if (a.length !== b.length) return false;
  for (let i = 0; i !== a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

export const escapeRegexpString = (value = '') => String(value).replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');

// TODO: use native Array.find, Array.findIndex when IE support is dropped
export const arrayFindIndex = function(arr, pred) {
  for (let i = 0; i !== arr.length; ++i) {
    if (pred(arr[i])) {
      return i;
    }
  }
  return -1;
};

export const arrayFind = function(arr, pred) {
  const idx = arrayFindIndex(arr, pred);
  return idx !== -1 ? arr[idx] : undefined;
};

// coerce truthy value to array
export const coerceTruthyValueToArray = function(val) {
  if (Array.isArray(val)) {
    return val;
  } else if (val) {
    return [val];
  } else {
    return [];
  }
};

export function find(arr, fn) {
  if (arr.find) {
    return arr.find(fn);
  }
  /* istanbul ignore next */
  let result;
  /* istanbul ignore next */
  arr.some(function(item, i, arr) {
    const ret = fn.call(this, item, i, arr);
    if (ret) {
      result = item;
      return ret;
    }
  });
  /* istanbul ignore next */
  return result;
}

export function remove(arr, item) {
  const index = arr.indexOf(item);
  if (index > -1) {
    arr.splice(index, 1);
  }
}

export function assert(condition, msg) {
  if (!condition) throw new Error(`[zoom-ui] ${msg}`);
}

export function param(obj) {
  if (!obj) {
    return '';
  }
  let s = [];
  for (let prefix in obj) {
    buildParams(prefix, obj[prefix], add);
  }

  function add(key, value) {
    s[s.length] = encodeURIComponent(key) + '=' +
      encodeURIComponent(value);
  };

  return s.join('&');
}

const rbracket = /\[\]$/;

function buildParams(prefix, obj, add) {
  let name;
  if (Array.isArray(obj)) {
    // Serialize array item.
    obj.forEach(function(v, i) {
      if (rbracket.test(prefix)) {
        // Treat each array item as a scalar.
        add(prefix, v);
      } else {
        // Item is non-scalar (array or object), encode its numeric index.
        buildParams(
          prefix + '[' + (typeof v === 'object' && v !== null ? i : '') + ']',
          v,
          add
        );
      }
    });
  } else if (typeof obj === 'object') {
    // Serialize object item.
    for (name in obj) {
      buildParams(prefix + '[' + name + ']', obj[name], add);
    }
  } else {
    // Serialize scalar item.
    add(prefix, obj);
  }
}

export function format(str, ...args) {
  if (!args) {
    return str;
  }
  return str.replace(/\{(\d+)\}/g, function(all, m) {
    if (args[m] !== undefined) {
      return args[m];
    }
    return all;
  });
}

export function pregQuote(str, delimiter) {
  return (str + '').replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\' + (delimiter || '') + '-]', 'g'), '\\$&');
}

export function xss(str) {
  return str.replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function deXss(str) {
  return str.replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, '\'')
    .replace(/&amp;/g, '&');
}

export const looseEqual = function(a, b) {
  const isObjectA = isObject(a);
  const isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    return JSON.stringify(a) === JSON.stringify(b);
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b);
  } else {
    return false;
  }
};

export const arrayEquals = function(arrayA, arrayB) {
  arrayA = arrayA || [];
  arrayB = arrayB || [];

  if (arrayA.length !== arrayB.length) {
    return false;
  }

  for (let i = 0; i < arrayA.length; i++) {
    if (!looseEqual(arrayA[i], arrayB[i])) {
      return false;
    }
  }

  return true;
};

export const isEqual = function(value1, value2) {
  if (Array.isArray(value1) && Array.isArray(value2)) {
    return arrayEquals(value1, value2);
  }
  return looseEqual(value1, value2);
};

export const isEmpty = function(val) {
  // null or undefined
  if (val == null) return true;

  if (typeof val === 'boolean') return false;

  if (typeof val === 'number') return !val;

  if (val instanceof Error) return val.message === '';

  switch (Object.prototype.toString.call(val)) {
    // String or Array
    case '[object String]':
    case '[object Array]':
      return !val.length;

    // Map or Set or File
    case '[object File]':
    case '[object Map]':
    case '[object Set]': {
      return !val.size;
    }
    // Plain Object
    case '[object Object]': {
      return !Object.keys(val).length;
    }
  }

  return false;
};
export const autoprefixer = function(style) {
  if (typeof style !== 'object') return style;
  const rules = ['transform', 'transition', 'animation'];
  const prefixes = ['ms-', 'webkit-'];
  rules.forEach(rule => {
    const value = style[rule];
    if (rule && value) {
      prefixes.forEach(prefix => {
        style[prefix + rule] = value;
      });
    }
  });
  return style;
};
export const kebabCase = function(str) {
  const hyphenateRE = /([^-])([A-Z])/g;
  return str
    .replace(hyphenateRE, '$1-$2')
    .toLowerCase();
};

export const capitalize = function(str) {
  if (!isString(str)) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const resolveAsyncComponent = function(component) {
  return new Promise((resolve, reject) => {
    let loadedLength = 0;

    function isCanResolve() {
      loadedLength++;
      if (loadedLength >= component.length) {
        resolve();
      }
    }

    if (Array.isArray(component)) {
      component.forEach(comp => {
        if (typeof comp === 'function') {
          comp().then((res) => {
            comp.resolved = ensureCtor(res, window.Vue);
            isCanResolve();
          }).catch((e) => {
            console.error(e);
            isCanResolve();
          });
        } else {
          isCanResolve();
        }
      });
    } else if (typeof component === 'function') {
      component().then((res) => {
        component.resolved = ensureCtor(res, window.Vue);
        resolve();
      }).catch((e) => {
        reject(e);
      });
    } else {
      resolve();
    }
  });
};

function ensureCtor(comp, base) {
  function isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
  }

  const hasSymbol =
    typeof Symbol !== 'undefined' && isNative(Symbol) &&
    typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp;
}

export function swap(arr, i, j) {
  const temp = arr[i];
  arr[i] = arr[j];
  arr[j] = temp;
}

export function findFirstParentOf(el, tag) {
  if (!el) {
    return null;
  }
  if (el.tagName === tag) {
    return el;
  }
  return findFirstParentOf(el.parentNode, tag);
}

function toInt(n) {
  return n === '' ? 0 : parseInt(n.trim(), 10);
}

function padZero(n) {
  return n < 10 ? '0' + n : n;
}
export function formatTime(num, isShowHourWhenZero = true) {
  const time = Math.floor(num);
  const h = parseInt(time / 3600, 10);
  const m = parseInt((time - h * 3600) / 60, 10);
  const s = parseInt(time % 60, 10);
  if (!isShowHourWhenZero && h === 0) {
    return `${padZero(m)}:${padZero(s)}`;
  }
  return `${padZero(h)}:${padZero(m)}:${padZero(s)}`;
}

export function formatNumber(time = '00:00:00') {
  const numbers = time.trim().split(':').reverse();
  const seconds = toInt(numbers[0] || '');
  const minutes = toInt(numbers[1] || '');
  const hours = toInt(numbers[2] || '');
  return seconds + hours * 3600 + minutes * 60;
}

export function isPromise(value) {
  return (
    value !== undefined && value !== null && typeof value.then === 'function'
  );
}

export function silencePromise(value) {
  if (isPromise(value)) {
    value.then(null, () => {});
  }
}
export function parseTime(timeStr) {
  // format: 00:00:10.650 || 00:00.10 || 00:10
  const [time, millisecond] = timeStr.split('.');
  return formatNumber(time) * 1000 + parseInt(millisecond || 0, 10);
}

/**
 * Find all Vue components in a component tree that match a given component name.
 * @param {Object} rootComponent - The root Vue component to start the search from.
 * @param {String} componentName - The name of the component to search for.
 * @param {Boolean} isDeep - Whether to search for components recursively in all descendants of the root component.
 * @returns {Array} An array of Vue component instances that match the given component name.
 */
export function findVueComponents(rootComponent, componentName, isDeep = true) {
  let matchingComponents = [];
  if (rootComponent.$options.name === componentName) {
    matchingComponents.push(rootComponent);
  }
  if (isDeep) {
    const childComponents = rootComponent.$children;
    if (childComponents) {
      for (const childComponent of childComponents) {
        const matchingChildComponents = findVueComponents(childComponent, componentName, true);
        matchingComponents = matchingComponents.concat(matchingChildComponents);
      }
    }
  } else {
    const directChildComponents = rootComponent.$children;
    if (directChildComponents) {
      directChildComponents.forEach(directChildComponent => {
        if (directChildComponent.$options.name === componentName) {
          matchingComponents.push(directChildComponent);
        }
      });
    }
  }
  return matchingComponents;
}

/**
 * Extracts all text content from a list of VNodes.
 * @param {Array} VNode List - The list of VNodes to extract text content from.
 * @returns {Array} An array of strings containing all the extracted text content.
 */
export function getTextContentFromVNodeList(vnodeList) {
  if (!vnodeList) return [];
  const textContentList = [];
  function getTextContentFromVNode(vnode) {
    if (!vnode) return;
    if (typeof vnode === 'string') {
      textContentList.push(vnode);
    } else if (vnode.text) {
      textContentList.push(vnode.text);
    } else if (Array.isArray(vnode.children)) {
      vnode.children.forEach(child => getTextContentFromVNode(child));
    }
  }
  vnodeList.forEach(vnode => getTextContentFromVNode(vnode));
  return textContentList;
}

